module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABGAgMAAAASiTqkAAAACVBMVEWA1taA1taA1tavitb3AAAAAnRSTlMAgJsrThgAAAB2SURBVDjLZcwhAQAgEMDAYQjxEYlGSjw3OXGd+9e4tmu5Oq5xbddygSWWWGKJJZZYYoklllhiiSWWWGKJJZZYYoklllhiiSWWWGKJJZZYYoklllhiiSWWWGKJJZZYYoklllhiiSWWWGKJJZZYYoklllhiibnmAXbEoDcL/SXcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/score_input_menu_open_bg.png
// module id = 364
// module chunks = 0